// extracted by mini-css-extract-plugin
export default {"wrapper":"game-page_wrapper__RZtyc","title":"game-page_title__RIUsW","table":"game-page_table__WDcEi","deleteResult":"game-page_deleteResult__EFyam"};